<template>
  <div id="body">
    <meta charset="utf-8" />
    <meta
      content="width=device-width,initial-scale=1,minimal-ui"
      name="viewport"
    />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic|Material+Icons"
    />
    <link href="https://fonts.googleapis.com/css2?family=Anton&display=swap" rel="stylesheet">

    <div id="app">
      <div id="p-top-div">
        <top-header></top-header>
      </div>
      <b-container id="p-view">
        <router-view class="main"></router-view>
        <footer class="footer">
          <database-footer></database-footer>
        </footer>
      </b-container>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import DatabaseFooter from '@/components/DatabaseFooter.vue';
import InputFile from './components/InputFile.vue';
import MY_JSON from './json/data.json';

export default {
  name: 'App',
  components: {
    TopHeader,
    InputFile,
    DatabaseFooter,
  },
  myJson: MY_JSON,
  data() {
    return {
      appstyle: {
        // backgroundImage: 'url(' + require('@/assets/img/2ndStruct.png') + ')',
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: '600px auto',
      },
    };
  },
};
</script>

<style>
#body {
  font-family: "IBM Plex Sans", Helvetica, Arial, sans-serif;
}
#p-top-div {
  background-color: #3b6fb6;
  width: 100%;
  padding: 0;
}
#app {
  padding: 0%;
  background-color: white;
  width: 100%;
}
#p-view {
  width: 70%;
  height: 60%;
}
img.backg {
  opacity: 0.3;
  top :18%;
  right: 6%;
  width: 300px;
  position: absolute;
}
a {
  color: #3a8ccf;
  text-decoration: none;
}
.navbar-expand {
  color: #3a8ccf;
}
.main {
    display: flex;
    flex-direction: column;
    height: 100%;
}
.header{
    flex: 0 0 auto;
}
.main{
    flex: 1 0 auto;
}
.footer{
    flex: 2 0 auto;
}
</style>
